<template>
    <div>
        <transition-group name="slide-left" tag="div">
            <div :class="[`alert-${message.type} alert`]" role="alert" v-for="(message, index) in messages" :key="`nm-${index}`">
                {{ message.message }} 
            </div>
        </transition-group>
    </div>
</template>
    
<script>
    export default {
        name: 'WexFlashMessage',
        props: {message: {},type: {},name: {},
            toast: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                messages: {}
            }
        },
        created() {
            if (this.message) {
                this.flash(this.message, this.type);
            }
            window.events.$on('flashmsg' + (this.name !== undefined ? this.name : ''),(message, type) => this.flash(message, type));
        },
        methods: {
            flash(message, type, title='Collsys') {
                if(this.toast){
                    this.$bvToast.toast(message, {
                        title: title,
                        autoHideDelay: 10000,
                        variant: type,
                        toaster: "b-toaster-top-center"
                    });
                } else {
                    const id = 'a_' + Math.random().toString(36).substr(2, 9)
                    this.messages[id] = {
                        message: message,
                        type: type
                    };
                    this.$forceUpdate();
    
                    setTimeout((id) => {
                        delete this.messages[id];
                        this.$forceUpdate();
                    },10000, id);
                }
            }
        }
    }
</script>